import React from 'react'
import { useI18n } from '../../../i18n'
import { Button } from '../../ui/Button'
import listStyles from '../../../styles/pages/governance/GovernanceListing.module.scss'

type NavMode = 'SEQUENTIAL' | 'FREE'

type Props = {
  navigationMode: NavMode
  onNavigationModeChange: (mode: NavMode) => void
}

export function ControlCentricNavigationModeBar({ navigationMode, onNavigationModeChange }: Props) {
  const { t } = useI18n()
  const primaryBtn = '!bg-green-600 hover:!bg-green-700 !border-green-600'

  return (
    <section className={`${listStyles.panel} !p-3`} data-testid="control-centric-nav-mode-bar">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            {t('complianceCenterUi.journey.modeLabel', 'Navigation mode')}
          </p>
          <p className="mt-0.5 text-xs text-slate-600">
            {navigationMode === 'FREE'
              ? t(
                  'controlCentric.navigation.freeHint',
                  'Browse and answer any control in any order. Progress is saved per control.',
                )
              : t(
                  'controlCentric.navigation.sequentialHint',
                  'Guided control-by-control walkthrough. You can switch to free navigation at any time.',
                )}
          </p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Button
            type="button"
            size="small"
            color={navigationMode === 'SEQUENTIAL' ? 'primary' : 'outline'}
            className={navigationMode === 'SEQUENTIAL' ? primaryBtn : undefined}
            onClick={() => onNavigationModeChange('SEQUENTIAL')}
          >
            {t('complianceCenterUi.journey.modeSequential', 'Sequential')}
          </Button>
          <Button
            type="button"
            size="small"
            color={navigationMode === 'FREE' ? 'primary' : 'outline'}
            className={navigationMode === 'FREE' ? primaryBtn : undefined}
            onClick={() => onNavigationModeChange('FREE')}
          >
            {t('controlCentric.controls.browseAll', 'Browse all controls (free navigation)')}
          </Button>
        </div>
      </div>
    </section>
  )
}
